import { BREAKPOINTS } from "../config/breakpoints";
import React, { useEffect, useState } from "react";
import { errorNotification, successNotification } from "../Generic/Notifications";
import { Table, Tbody, Tcol, Thead, Trow } from "../Generic/Table";
import { connect } from "react-redux";
import styled from "styled-components";
import EmptyState from "../Generic/EmptyState";
import Loader from "../Generic/Loader";
import { beautifyKey } from "../util/util";
import TaskService from "./services";
import Timestamp from "../Generic/Timestamp";

const Page = styled.div`
	display: flex;
	height: max-content;
	overflow-y: auto;
	overflow-x: hidden;
	flex-direction: column;
	text-align: left;
	width: 100%;
	padding: 2rem;
	@media (max-width: ${BREAKPOINTS.tablet}px) {
		padding: 1rem;
	}
`;

const Header = styled.div`
    display:flex;
    font-size:2rem;
    margin:0 0 1rem 0.5rem;
    @media (max-width: ${BREAKPOINTS.tablet}px) {
        font-size: 1.5rem;
    }
`;

const CenteredContainer = styled.div`
	width: 100%;
	height: max-content;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: ${(props) => props.margin};
`;

const ActiveTasks = (props) => {

	const { kitchenId } = props;
    const [activeTasks, setActiveTasks] = useState(null);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState('');
	const [flaggedForRemoval, setFlaggedForRemoval] = useState([]);

	async function getActiveTasks() {
		setLoading(true);
		const { data, error } = await TaskService.getActiveTasks(kitchenId);
		if(data) {
			setActiveTasks(data);
		}
		if(error) {
			setError(error);
		}
		setLoading(false);
	}

	async function retryCall() {
		setError('');
		setLoading(true);
		getActiveTasks();
	}

	async function handleTaskKillRequest(taskId) {
		const payload = { taskId };
		setFlaggedForRemoval(prev => ([ ...prev, taskId]));
		const { data, error } = await TaskService.killActiveTask(payload);
		if(data) {
			successNotification('Task Cleared');
			getActiveTasks()
		}
		if(error) {
			errorNotification('Failed to clear active task');
		}
		setFlaggedForRemoval(prev => prev.filter(task => task !== taskId));
	}

	function renderActiveTasks(activeTasks, loading, error) {
		if(loading) {
			return <CenteredContainer> <Loader /> </CenteredContainer>;
		}
		if(error) {
			return <EmptyState message="Could not fetch active tasks" retry={retryCall} ></EmptyState> ;
		}
		if(!activeTasks || !activeTasks.length) {
			return <EmptyState message="No Active tasks found" retry={retryCall} retryButtonText="Search again" ></EmptyState> ;
		}

		const tasksRenderData = activeTasks ? activeTasks.map((task) => {
			const { _id, taskType, taskGroupId, estimatedStartTime, estimatedEndTime } = task,
				isgettingRemoved = flaggedForRemoval.includes(_id);
			return (
				<Trow disabled={isgettingRemoved} hoverEffect={false} breakpoint="800px" >
					<Tcol title="Task ID" borderRadius="10px 0 0 10px" breakpoint="800px">{_id}</Tcol>
					<Tcol title="Task Type" breakpoint="800px">{beautifyKey(taskType)}</Tcol>
					<Tcol title="Task Group ID" breakpoint="800px">{taskGroupId}</Tcol>
					<Tcol title="Est. Start Time" breakpoint="800px"><Timestamp value={estimatedStartTime} /></Tcol>
					<Tcol title="Est. End Time" breakpoint="800px"><Timestamp value={estimatedEndTime} /></Tcol>
					<Tcol title="" borderRadius="0 10px 10px 0" breakpoint="800px">
						<span onClick={() => handleTaskKillRequest(_id)} class="material-symbols-outlined remove-symbol">
							delete
						</span>
					</Tcol>
				</Trow>
			);
		}) : "";
		return (
			<Table breakpoint="800px">
				<Trow head breakpoint="800px">
					<Thead>Task ID</Thead>
					<Thead>Task Type</Thead>
					<Thead>Task Group ID</Thead>
					<Thead>Estimated Start Time</Thead>
					<Thead>Estimated End Time</Thead>
					<Thead></Thead>
				</Trow>
				<Tbody>{tasksRenderData}</Tbody>
			</Table>
		);
	}

	useEffect(() => {
		getActiveTasks();
	}, []);

	return (
		<Page>
			<Header>
				Active Tasks
			</Header>
			{renderActiveTasks(activeTasks, loading, error)}
		</Page>
	);
};

const mapStatetoProps = (state) => {
	const { kitchen, landing } = state;
	return {
		kitchenId: landing.kitchenId,
		machineID: landing.machineID,
		...kitchen,
	};
};

export default connect(mapStatetoProps, {})(ActiveTasks);
